import script from "./NavigationDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationDrawer.vue?vue&type=script&setup=true&lang=js"

import "./NavigationDrawer.vue?vue&type=style&index=0&id=3a73fd81&lang=css"

const __exports__ = script;

export default __exports__